import { tsv } from "@faire/slate/lib/tsv";
import { hasText } from "@faire/slate/private/shared/type-utils";
import type { IText } from "@faire/slate/private/shared/types";
import React from "react";

type IProps = {
  helper?: IText;
  error?: IText;
  layout?: "stack" | "inline";
};

export const ModalFooterTexts: React.FC<IProps> = ({
  helper,
  error,
  layout = "stack",
}) => {
  const hasHelper = hasText(helper);
  const hasError = hasText(error);

  if (!hasHelper && !hasError) {
    return null;
  }

  return (
    <div
      className={footerTextsStyle.cls({
        layout,
      })}
    >
      {hasHelper ? <p className="fs-modal__footer-helper">{helper}</p> : null}
      {hasError ? (
        <p className="fs-modal__footer-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
};

const footerTextsStyle = tsv({
  base: "fs-modal__footer-texts",
  variants: {
    layout: {
      stack: "",
      inline: "fs-modal__footer-texts--inline",
    },
  },
});
